"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerEdit = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const design_player_username_1 = require("@unboared/design.player.username");
const design_player_avatar_edit_1 = require("@unboared/design.player.avatar_edit");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
function PlayerEdit(_a) {
    var { size = 40 } = _a, props = __rest(_a, ["size"]);
    const { username, avatar, master, color, onPress } = props;
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    return (react_1.default.createElement(react_native_1.View, { style: styles.player },
        react_1.default.createElement(react_native_1.View, { style: styles.avatar },
            react_1.default.createElement(design_player_avatar_edit_1.AvatarEdit, { name: avatar, color: color, size: size, onPress: onPress })),
        react_1.default.createElement(react_native_1.View, { style: [styles.username, { marginLeft: normalize(size / 4) }] },
            react_1.default.createElement(design_player_username_1.Username, { name: username, size: size / 3, master: master }))));
}
exports.PlayerEdit = PlayerEdit;
const styles = react_native_1.StyleSheet.create({
    player: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    avatar: {
        position: 'relative',
    },
    username: {},
});
//# sourceMappingURL=player_edit.js.map